module.exports = __webpack_public_path__ + "img/ico-jiancha@2x.5666f0cd.png";